import StudentExamCalendarPageContainer from "../../components/courses/studentCoursesList/examCalendar";

const StudentExamCalendar = () => {
  return <StudentExamCalendarPageContainer />;
};
export default StudentExamCalendar;
